export const DEFAULT_SIZE = 65000;
export const MAX_DATASOURCES = 20;
export const INPUT_DATETIME = "yyyy-MM-dd'T'HH:mm";
export const DATE_FORMAT_API = 'yyyy.MM.dd HH:mm:ss';
export const backgroundColors = [
  '#1da2c5', '#6df591', '#b15caa', '#8a8c79', '#3edb35',
  '#1decd5', '#CB2821', '#86504a', '#CDA434', '#696969',
  '#D46A48', '#9E99D8', '#465CDF', '#6E369F', '#ED35A9',
  '#0a8871', '#ffb335', '#000', '#ff4500', '#acb8c3',
];
/**
 * Сортировка массива по шаблону, по указанному свойству
 * @param source - исходный массив
 * @param target - массив, по которому сортировать
 * @param property - свойство, по которому сортировать
 * @returns {*[]}
 */
export const sort = (source, target, property) => {
  const tmp = [];
  target.forEach((obj) => {
    tmp.push(source.find((sObj) => `${sObj[property]}` === `${obj}`));
  });
  return tmp;
};

export const shouldBeValue = {
  WARNING: 'WARNING',
  DANGER: 'DANGER',
  EMPTY: 'EMPTY',
};